import {useEffect, useRef, useState} from 'react';
import {initAligningGuidelines} from './controls/align_lines';
import fabric from './fabric';

export const CanvasStickers = ({configJson, onChange, setCanvas, onLoad}) => {
  const [loading, setLoading] = useState(false);
  const canvasEl = useRef(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: ignore dependencies
  useEffect(() => {
    const canvasInstance = new fabric.Canvas(canvasEl.current, {
      width: 0,
      height: 0,
      includeDefaultValues: false,
      selection: !evite.detects.isMobile,
      allowTouchScrolling: true,
    });

    canvasInstance.setZoom(0.5);

    initAligningGuidelines(canvasInstance);

    const setCurrentDimensions = () => {
      const canvasSizer = document.getElementById('canvas__wrapper__stickers');

      if (canvasSizer) {
        const width = canvasSizer.offsetWidth;
        const height = canvasSizer.offsetHeight;
        const scale = width / canvasInstance.getWidth();
        const zoom = canvasInstance.getZoom() * scale;
        canvasInstance.setDimensions({width, height});
        canvasInstance.setViewportTransform([zoom, 0, 0, zoom, 0, 0]);
      }
    };

    canvasInstance.setCurrentDimensions = setCurrentDimensions;

    window.addEventListener('resize', setCurrentDimensions, false);

    const onChangeHandler = () => {
      if (!loading)
        onChange(canvasInstance.toJSON(['dataUrl', 'delay', 'frameWidth', 'framesLength']));
    };

    canvasInstance.on({
      'object:modified': onChangeHandler,
      'object:added': onChangeHandler,
      'object:removed': onChangeHandler,
    });

    const loadCanvas = (config) => {
      setLoading(true);
      const reviver = async (json, obj) => {
        if (obj.type === 'gif') {
          fabric.util.requestAnimFrame(function render() {
            canvasInstance?.renderAll();
            fabric.util.requestAnimFrame(render);
          });
        }

        setLoading(false);
        if (onLoad) onLoad();
        setCurrentDimensions();
      };
      canvasInstance.loadFromJSON(config, null, reviver);
    };
    if (configJson) loadCanvas(configJson);

    setCanvas(canvasInstance);
    setCurrentDimensions();

    return () => {
      canvasInstance.dispose();
      window.removeEventListener('resize', setCurrentDimensions);
    };
  }, []);

  return <canvas ref={canvasEl} />;
};
